<template>
    <div>
        <div class="row columns">
            <div class="panel-title">
                {{rankingGroup.name}}
            </div>
            <div class="panel-content">
                <ul class="tabs horizontal" data-tab>
                    <li @click="activatedTab = 1"><a :class="{activated : activatedTab === 1}">Général</a></li>
                    <li @click="activatedTab = 2"><a :class="{activated : activatedTab === 2}">Détaillé</a></li>
                    <li @click="activatedTab = 3"><a :class="{activated : activatedTab === 3}">Bash</a></li>
                    <li @click="activatedTab = 4"><a :class="{activated : activatedTab === 4}">Agressions</a></li>
                    <li @click="activatedTab = 5"><a :class="{activated : activatedTab === 5}">Touchdowns</a></li>
                    <li @click="activatedTab = 6"><a :class="{activated : activatedTab === 6}">classement de la honte</a></li>
                    <li @click="activatedTab = 7"><a :class="{activated : activatedTab === 7}">points bonus</a></li>
                </ul>
                <br>
                <div v-if="activatedTab === 1">
                    <generalRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup" :needDB="needDB"></generalRanking>
                </div>
                <div v-if="activatedTab === 2">
                    <detailedRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup"></detailedRanking>
                </div>
                <div v-if="activatedTab === 3">
                    <bashRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup"></bashRanking>
                </div>
                <div v-if="activatedTab === 4">
                    <foulRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup"></foulRanking>
                </div>
                <div v-if="activatedTab === 5">
                    <tdRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup"></tdRanking>
                </div>
                <div v-if="activatedTab === 6">
                    <shameRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup"></shameRanking>
                </div>
                <div v-if="activatedTab === 7">
                    <bonusPointRanking :selectedWeek="selectedWeek" :rankingGroup="rankingGroup"></bonusPointRanking>
                </div>
            </div>
            <!-- <div v-else>
                <spinner></spinner>
            </div> -->
        </div>
    </div>
</template>

<script>
import generalRanking from './general-ranking.vue'
import detailedRanking from './detailed-ranking.vue'
import bashRanking from './bash-ranking.vue'
import foulRanking from './foul-ranking.vue'
import tdRanking from './td-ranking.vue'
import shameRanking from './shame-ranking.vue'
import bonusPointRanking from './bonus-point-ranking.vue'

export default {
  name: 'RankingGroup',
  components: {
    generalRanking,
    detailedRanking,
    bashRanking,
    foulRanking,
    tdRanking,
    shameRanking,
    bonusPointRanking
  },
  data () {
    return {
      activatedTab: 1
    }
  },
  props: {
    'rankingGroup': null,
    'selectedWeek': null,
    'needDB': null
  },
  methods: {
    previous () {
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.activated {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

</style>



// WEBPACK FOOTER //
// ranking-group.vue?4b3cc625